module.exports = "https://static.wmbcdn.com/uniweb/images/f1ad72fa72a1a1716f3da9abeb3269af.svg";